import React from 'react';
import { TitleUI, SubtitleUI } from './LabelTitleUI';
import BackButton from './BackButton';
import { withRouter } from 'react-router-dom';

const Breadcrumbs = (props) => {
    return (
        <>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    {
                        props.title !== undefined ?
                            <TitleUI icon={props.title.icon} label={props.title.label} />
                            : null
                    }
                    {
                        props.subtitles && props.subtitles.map((subtitle, index) => <SubtitleUI key={index.id ? `sbUI-${index.id}-${index}` : `sbUI${index}`} icon={subtitle.icon} label={subtitle.label} separator={props.title !== undefined ? true : false} />)
                    }
                </div>
            </div>
        </>
    );
};

export default withRouter(Breadcrumbs);
